module.exports = __webpack_public_path__ + "img/Large-Semi-Elliptical-Attachment-R-31.f73f7b7c.png";